import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IInputProps } from '../components/form/form-email-with-submit/form-email-with-submit';

export class InputTextModel extends ContentItem {
  get name(): string {
    return get(this._config, 'elements.name.value', '');
  }

  get label(): string {
    return get(this._config, 'elements.label.value', '');
  }

  get errorMessage(): string {
    return get(this._config, 'elements.error_message.value', '');
  }

  get type(): string {
    return get(this._config, 'elements.type.value[0].codename', 'text');
  }

  get required(): boolean {
    return get(this._config, 'elements.required.value[0].codename', '') ===
      'true'
      ? true
      : false;
  }

  public static create(data: IInputText): IInputProps {
    const { label, errorMessage, required, name, type } = new InputTextModel(
      data
    );
    return {
      label,
      errorMessage,
      required,
      name,
      type
    };
  }
}
